import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslations } from '../i18n';
import { Dashboard } from './Dashboard';
import { demoCars, demoLogEntries } from '../data/demoPagesData';
import { AddRecordForm } from './AddRecordForm';
import { Statistics2 } from './Statistics2';
import { NavigationBar } from '../components/ui/NavigationBar';

export function DemoView() {
  const { view } = useParams();
  const [searchParams] = useSearchParams();
  const { t } = useTranslations();
  const navigate = useNavigate();
  const isPreview = searchParams.get('preview') === 'true';

  if (view === 'garage') {
    return (
      <div className={`min-h-screen ${isPreview ? 'preview-mode' : ''}`}>
         <Dashboard 
            cars={demoCars.filter(c => !c.is_shared && !c.is_archived)} 
            favoriteCars={demoCars.filter(c => c.is_favorite)}
            sharedCars={demoCars.filter(c => c.is_shared)}
            onCarClick={(car) => navigate(`/demo/insights?car=${car.id}&preview=${isPreview}`)}
            onAddCar={() => {}}
         />
      </div>
    );
  }

  if (view === 'new-expense') {
    // Show new expense with blurred background or just the form
    return (
      <div className={`min-h-screen bg-page-gradient ${isPreview ? 'preview-mode' : ''}`}>
        <AddRecordForm 
          carId={demoCars[0].id}
          selectedCarOverride={demoCars[0]}
          onExpenseAdded={() => {}} 
          onClose={() => {}} 
          isDemo={true}
        />
      </div>
    );
  }

  if (view === 'insights') {
    const carId = searchParams.get('car') || demoCars[0].id;
    const car = demoCars.find(c => c.id === carId) || demoCars[0];
    const logEntries = demoLogEntries.filter(e => e.car_id === car.id);

    return (
      <div className={`min-h-screen bg-transparent ${isPreview ? 'preview-mode' : ''}`}>
        <div className="fixed inset-0 z-[60] flex flex-col">
          <div className="relative z-10 flex-shrink-0">
            <NavigationBar 
              title={t.tabs.stats}
              onBack={() => navigate(-1)}
              fixed={false}
            />
          </div>
          <div className="relative z-10 flex-1 overflow-y-auto no-scrollbar pt-4 pb-20">
            <Statistics2 
              logEntries={logEntries} 
              selectedYear="all" 
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8 text-center">
      <h1 className="text-2xl font-bold">Demo View Not Found</h1>
    </div>
  );
}
